/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert a number between binary, octal, decimal, and hexadecimal all at once. Pick the base you're entering and get the rest instantly.`)
};

const es_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte un número entre binario, octal, decimal y hexadecimal a la vez. Elige la base que estás usando y obtén el resto al instante.`)
};

const de_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechne eine Zahl gleichzeitig zwischen Binär, Oktal, Dezimal und Hexadezimal um. Wähle die Basis, die du eingibst, und erhalte den Rest sofort.`)
};

const nl_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer een getal tussen binair, octaal, decimaal en hexadecimaal allemaal tegelijk. Kies de basis waarin u het getal invoert en de andere drie verschijnen direct.`)
};

const fr_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez un nombre entre binaire, octal, décimal et hexadécimal à la fois. Choisissez la base dans laquelle vous entrez et obtenez les autres instantanément.`)
};

const it_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti un numero tra binario, ottale, decimale ed esadecimale tutto in una volta. Scegli la base in cui stai scrivendo e ottieni gli altri istantaneamente.`)
};

const pt_br2_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta um número entre binário, octal, decimal e hexadecimal de uma vez. Escolha a base que está inserindo e obtenha o resto instantaneamente.`)
};

const pt_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta um número entre binário, octal, decimal e hexadecimal em simultâneo. Escolha a base que está a introduzir e obtenha os restantes instantaneamente.`)
};

const ja_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値を二進法、八進法、十進法、十六進法で相互変換します。入力するベースを選択すると、他の3つの形式がすぐに表示されます。`)
};

const zh_nb_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性在二进制、八进制、十进制和十六进制之间转换数字。选择你输入的进制，立即获得其余各进制的结果。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const nb_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.nb_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("nb_intro", locale)
	if (locale === "en") return en_nb_intro(inputs)
	if (locale === "es") return es_nb_intro(inputs)
	if (locale === "de") return de_nb_intro(inputs)
	if (locale === "nl") return nl_nb_intro(inputs)
	if (locale === "fr") return fr_nb_intro(inputs)
	if (locale === "it") return it_nb_intro(inputs)
	if (locale === "pt-BR") return pt_br2_nb_intro(inputs)
	if (locale === "pt") return pt_nb_intro(inputs)
	if (locale === "ja") return ja_nb_intro(inputs)
	return zh_nb_intro(inputs)
};